// import producerService from './producerService';
// import logService from './logService';
import { default as _isEmpty } from 'lodash/isEmpty';
import { default as _each } from 'lodash/each';
import { default as _size } from 'lodash/size';
// import apiUrl from '../utils/apiUrl';

import dayjs from 'dayjs';
import { impressionConstants } from '../utils/constants';

// const MAX_RETRY_COUNT = impressionConstants.MAX_RETRY_COUNT;
// const INITIAL_NETWORK_RETRY_DELAY =
//   impressionConstants.INITIAL_NETWORK_RETRY_DELAY;
const MIN_ENGAGEMENT_TIME = impressionConstants.MIN_ENGAGEMENT_TIME; //in milliseconds

// const producerApiUrl = apiUrl.IMPRESSION_API_URL;

let currentEventsArray = [];
// let eventsToBeFired = [];
let impressionObjs = {};
// let requestInFlight = false;

function untrackedExitedEvents() {
  const newImpressionMap = {};
  _each(impressionObjs, function (impObj, key) {
    if (impObj.startTime) {
      const objStartTime = impObj.startTime;
      const currentTime = dayjs().valueOf();

      //Check difference with current time & the start time of the element which registered the enter event so that the elements in the viewport aren't to be included in this scenario as user is still looking at them. Because for the elements in the current view port, exit event isn't registered yet and that they shouldn't be included.
      if (currentTime - objStartTime >= 150) {
        impObj.engagementTime = currentTime - objStartTime;
        newImpressionMap[key] = impObj;
      }
    }
  });

  const newImpressionObjsCount = _size(newImpressionMap);
  //If the count of the events which haven't registered exit events are greater than or equal to 3, fire them.
  if (newImpressionObjsCount >= 3) {
    fireEventsLeft(newImpressionMap);
  }
}

function trackEntry(impressionObj, postObj) {
  if (!impressionObj) return;
  impressionObj.startTime = postObj.startTime;
  impressionObjs[postObj.id] = impressionObj;

  const impressionObjsCount = _size(impressionObjs);

  //To handle the case where the elements which haven't registered the exit events.
  if (impressionObjsCount >= 5) {
    untrackedExitedEvents();
  }
}

//Fire the events left out when and if required. For ex. while unmouting the feed component. Fire the events in the view port which haven't been pushed yet.
function fireEventsLeft(impressionsMap) {
  //Use the arg value if the elements are specific else pick default impressions map.
  const impressions = impressionsMap || impressionObjs;
  if (!_isEmpty(impressions)) {
    _each(impressions, function (impressionObj, postId) {
      trackExit(impressionObj, { id: postId });
    });
  }
}

function trackExit(impressionObj, postObj) {
  if (!impressionObjs[postObj.id]) {
  } else {
    const startTimeInMs = impressionObjs[postObj.id].startTime;
    //set endtime as current time for those elements still in the current viewport and are to be fired while unmounting component.
    const endTimeInMs = postObj.endTime ? postObj.endTime : dayjs().valueOf();
    impressionObj.engagementTime = impressionObj.engagementTime
      ? impressionObj.engagementTime
      : endTimeInMs - startTimeInMs;
    impressionObj.timestamp = startTimeInMs;

    if (
      impressionObj.engagementTime &&
      impressionObj.engagementTime > MIN_ENGAGEMENT_TIME
    ) {
      delete impressionObj.startTime;
      currentEventsArray.push(impressionObj);
    }
    delete impressionObjs[postObj.id];
  }
}
function trackSumoEntry(impressionObj, postObj) {
  if (!impressionObj) return;
  impressionObj.startTime = postObj.startTime;
  impressionObjs[impressionObj.trackId] = impressionObj;

  const impressionObjsCount = _size(impressionObjs);

  //To handle the case where the elements which haven't registered the exit events.
  if (impressionObjsCount >= 5) {
    untrackedExitedEvents();
  }
}

// let firingEvents = async (numTries = 0) => {
//   const delay =
//     INITIAL_NETWORK_RETRY_DELAY + INITIAL_NETWORK_RETRY_DELAY * numTries;

//   if (requestInFlight) {
//     //do nothing.
//   } else {
//     if (!eventsToBeFired.length) {
//       //new events are pushed into eventsToBeFired array if the array is empty.
//       eventsToBeFired = eventsToBeFired.concat(currentEventsArray);
//       currentEventsArray = [];
//     }

//     // eventsToBeFired.length && console.log('eventsToBeFired:', eventsToBeFired);
//     if (eventsToBeFired.length) {
//       requestInFlight = true;
//       try {
//         await producerService.post(producerApiUrl, {
//           userEvents: eventsToBeFired,
//         });
//         numTries = 0;
//         requestInFlight = false;
//         eventsToBeFired = []; //clear currentEvents triggered.
//       } catch (error) {
//         if (error.readyState < 4) {
//           if (numTries <= MAX_RETRY_COUNT) {
//             numTries++;
//           }
//         } else if (error && error.response) {
//           //request payload error.
//           //Logging to sentry.
//           logService.error(error, { response: error.response.data });
//         } else {
//           //nothing.
//         }
//         requestInFlight = false;
//       }
//     }
//   }
//   // await delay;
//   return Delay(delay).then(() => {
//     firingEvents(numTries);
//   });
// };

// function Delay(duration) {
//   return new Promise((resolve) => {
//     setTimeout(() => resolve(), duration);
//   });
// }

// firingEvents();

export default { trackEntry, trackExit, fireEventsLeft, trackSumoEntry };
